module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/explore-8d825c789b658333bbff9494c688a117.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/explore.svg
// module id = 8VGS
// module chunks = 24